import z from "zod";
export function serializeQuery(query) {
    const queryWithStrings = Object.fromEntries(Object.entries(query)
        .filter((e) => !!e[1])
        .map(([k, v]) => {
        if (Array.isArray(v)) {
            return [k, v.join(", ")];
        }
        else {
            return [k, v.toString()];
        }
    }));
    return new URLSearchParams(queryWithStrings);
}
export function zodQueryBoolean() {
    return z
        .string()
        .optional()
        .transform((string) => {
        // Not provided
        if (!string)
            return undefined;
        const lc = string.toLowerCase();
        // False
        if (lc === "0" || lc === "false")
            return false;
        // True
        if (lc === "1" || lc === "true")
            return true;
        // Unknown
        return undefined;
    });
}
